import React, { useEffect, useRef, useState } from "react";
import CalendarHeader from "./calendar-header";
import CalendarWeekView from "./calendar-week-view";
import WorkWeek from "./calendar-work-week";
import Agenda from "./agenda";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DayView from "./day-view";
import Header from "../../common/header/Header";
import axios from "axios";

import { ENDPOINTS } from "../../../js/api/_config";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../../reducer/slices/user/userSlice";
import { getRecruiterLists } from "../../../reducer/slices/recruiter/get-recruiter-slice";
import Recruiter from "./recruiter";
import { Toast } from "../../common/toast/toast";
import { Device } from "@twilio/voice-sdk";
import { getLiveCallStatus } from "../../../js/api/twilio";
import ringing_Audio from "../../../assets/audio/ringtone.mp3";
import { setCallData } from "../../../reducer/slices/twilio-calls/call-slice";
import { useSignalR } from "../../../context/Signalr-context";
import { format, isValid, parseISO } from "date-fns";
let ringingAudio = new Audio(ringing_Audio);

const Calendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [view, setView] = useState("Work Week");
  const [isAgendaOpen, setIsAgendaOpen] = useState(false);
  const [isRecruiterOpen, setIsRecruiterOpen] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [loader, setLoader] = useState(true);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState("group");
  const [fetchRecruiterPayload, setfetchRecruiterPayload] = useState(null);
  const [toasts, setToasts] = useState([]);
  const [callCount, setCallCount] = useState([]);

  // Twilio Calls
  const [trialInfo, setTrialInfo] = useState(null);
  const [status, setStatus] = useState("Calling");
  const [isReady, setIsReady] = useState(false);
  const [callSid, setCallSid] = useState(null);
  const [mute, setMute] = useState(false);
  const [connection, setConnection] = useState();
  const [callErrorMsg, setCallErrorMsg] = useState();
  const [callingModal, setCallingModal] = useState(false);
  const [isMiniScreen, setIsMiniScreen] = useState(false);
  const [isChat, setIsChat] = useState(true);
  const { hubConnection } = useSignalR();
  let callDurationInterval = null;
  let elapsedSeconds = 0;
  const deviceRef = useRef(null);

  // End Twilio Calls

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  // Filter the recruiter
  const getCurrentDateTime = () => {
    const now = new Date();
    return now.toISOString().slice(0, 16); // Format for datetime-local input
  };
  const [selectedRecruiterId, setSelectedRecruiterId] = useState("");
  const [startDate, setStartDate] = useState(getCurrentDateTime());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [clearFilter, setClearFilter] = useState(false);

  useEffect(() => {
    setStartDate(getCurrentDateTime());
    setEndDate(getCurrentDateTime());
  }, []);
  // Filter the recruiter

  const [allEvents, getAllEvents] = useState([]);

  const getDateRangeByView = (date, view) => {
    const current = new Date(date);
    const day = current.getDay(); // 0 (Sun) to 6 (Sat)
    const result = { startDate: null, endDate: null };

    switch (view) {
      case "Week": {
        const diffToMonday = day === 0 ? -6 : 1 - day;
        const monday = new Date(current);
        monday.setDate(current.getDate() + diffToMonday);
        monday.setHours(0, 0, 0, 0);

        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        sunday.setHours(23, 59, 59, 999);

        result.startDate = monday;
        result.endDate = sunday;
        break;
      }
      case "Work Week": {
        const diffToMonday = day === 0 ? -6 : 1 - day;
        const monday = new Date(current);
        monday.setDate(current.getDate() + diffToMonday);
        monday.setHours(0, 0, 0, 0);

        const friday = new Date(monday);
        friday.setDate(monday.getDate() + 4);
        friday.setHours(23, 59, 59, 999);

        result.startDate = monday;
        result.endDate = friday;
        break;
      }
      case "Day": {
        // IST start of selected day
        const startIST = new Date(current);
        startIST.setHours(0, 0, 0, 0);

        // Convert IST → UTC (manual)
        const startUTC = new Date(
          startIST.getTime() - startIST.getTimezoneOffset() * 60000
        );

        // UTC end of same calendar day
        const endUTC = new Date(startUTC);
        endUTC.setUTCHours(23, 59, 59, 999);

        result.startDate = startIST;
        result.endDate = endUTC;
        break;
      }
      default:
        break;
    }

    return result;
  };

  const { userProfile } = useSelector((state) => state.user);
  const recruiterData = useSelector(
    (state) => state.recruiter_list?.data.items || []
  );
  const recruiterDataHasCalendar = recruiterData?.filter(
    (r) => r.hasCalendar === true && r.isActive == true
  );
  useEffect(() => {
    dispatch(fetchUserProfile({}));
    dispatch(getRecruiterLists({}));
  }, []);

  const recruiterEmail = userProfile?.email;
  const currentRecruiter = recruiterData?.filter(
    (r) => r.recruiterEmail === recruiterEmail
  );
  const recID = currentRecruiter[0]?.recruiterID;

  const toggleAgenda = () => {
    setIsAgendaOpen((prev) => !prev);
  };
  const toggleRecruiter = () => {
    setIsRecruiterOpen((prev) => !prev);
  };

  const handleSelection = (value) => {
    setSelectedEvent(false);
    setSelectedValue(value);
  };

  const getRecPayload = () => {
    const recruiterId =
      selectedValue === "single" ? currentRecruiter[0]?.recruiterID : null;

    // Always re-calculate with latest view and date
    const { startDate, endDate } = getDateRangeByView(
      new Date(currentDate),
      view
    );

    return {
      recruiterId,
      startDate,
      endDate,
    };
  };

  useEffect(() => {
    fetchEvents(selectedValue);
  }, [view]);
  useEffect(() => {
    fetchEvents(selectedValue);
  }, [currentDate]);

  const fetchEvents = async (selectedValue, customPayload = false) => {
    // Start loader with delay
    let loaderTimer = setTimeout(() => {
      setLoader(true);
    }, 1000); // Show loader only if fetch takes longer than 300ms

    const Recpayload = getRecPayload();

    const payload = customPayload
      ? customPayload
      : (fetchRecruiterPayload && fetchRecruiterPayload.startDate) ||
        (fetchRecruiterPayload && fetchRecruiterPayload.endDate)
      ? fetchRecruiterPayload
      : Recpayload;
    console.log("testing payload", JSON.stringify(payload));

    try {
      const response = await axios.post(ENDPOINTS.CALENDAR.GET_EVENTS, payload);
      getAllEvents(response.data.data);
    } catch (error) {
      console.error("API Error =>", error);
    } finally {
      clearTimeout(loaderTimer); // Stop timer if fetch finished early
      setLoader(false); // Stop loader
    }
  };

  const getCalendarEventCount = async () => {
    const Recpayload = getRecPayload();
    const payload =
      (fetchRecruiterPayload && fetchRecruiterPayload.startDate) ||
      (fetchRecruiterPayload && fetchRecruiterPayload.endDate)
        ? fetchRecruiterPayload
        : Recpayload;

    const start = new Date(payload.startDate);
    start.setUTCHours(0, 0, 0, 0);

    const end = new Date(payload.endDate);
    end.setUTCHours(23, 59, 59, 999);

    const params = {
      ...payload,
      startDate: start,
      endDate: end,
    };

    try {
      const response = await axios.post(
        ENDPOINTS.CALENDAR.GET_CALENDER_EVENTS_COUNT,
        params
      );
      if (response.data && response.data.success) {
        const formattedData = response.data.data.map((item) => {
          const parsedDate = parseISO(item?.date || "");
          return {
            ...item,
            date: isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "",
          };
        });

        setCallCount(formattedData);
      } else {
        setCallCount([]);
      }
      //return response.data;
    } catch (error) {
      setCallCount([]);
    }
  };

  // Fetch events whenever selectedValue changes
  useEffect(() => {
    fetchEvents(selectedValue);
  }, [selectedValue, recID]);

  const [isOpen, setIsOpen] = useState(false);
  const [meetId, setMeetId] = useState(null);
  const [calOpen, setCalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  console.log('selectedEvent', selectedEvent)
  const cancelMeeting = async () => {
    if (meetId) {
      try {
        await axios.put(
          `${ENDPOINTS.CALENDAR.CANCEL_EVENT}?calendarEventID=${meetId}&isOpen=false`
        );

        // Ensure `fetchEvents` is called after successful request
        setCalOpen(false);
        setIsOpen(false);
        setSelectedEvent(null);
        fetchEvents(selectedValue);
      } catch (error) {
        console.error("Error canceling the meeting:", error);
      }
    }
    setCalOpen(false);
    setIsOpen(false);
  };

  const closePopup = () => {
    setCalOpen(false);
  };

  // Twilio calls

  const handleCall = async (phoneNumber) => {
    if (!phoneNumber) {
      setStatus("Please enter a phone number");
      return;
    }

    dispatch(
      setCallData({
        params: {
          To: phoneNumber,
          PatientID: trialInfo.patientID,
          PatientTrialJuncID: trialInfo.patientTrialJuncID,
          UserID: userProfile.userID,
        },
        trialInfo,
        call: true,
        route: `/conversation-list/${trialInfo.patientTrialJuncID}`,
      })
    );
  };

  useEffect(() => {
    getCalendarEventCount();
  }, [view, currentDate, selectedValue, fetchRecruiterPayload]);

  useEffect(() => {
    if (!hubConnection) return;

    const handleNotification = (message) => {
      const { event_type } = message;
      if (event_type === "calendarcallcount") {
        getCalendarEventCount();
      }
    };

    hubConnection.on("notification", handleNotification);

    return () => {
      hubConnection.off("notification", handleNotification);
    };
  }, [hubConnection]);

  return (
    <>
      <Header headertitle="Calendar" />
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
      {isChat ? (
        <div className="w-full mx-auto relative">
          <CalendarHeader
            currentDate={currentDate}
            setCurrentDate={setCurrentDate}
            view={view}
            setView={setView}
            showDatePicker={showDatePicker}
            setShowDatePicker={setShowDatePicker}
            openAgenda={toggleAgenda}
            setIsAgendaOpen={setIsAgendaOpen}
            onSelect={handleSelection}
            setIsRecruiterOpen={setIsRecruiterOpen}
            isRecruiterOpen={isRecruiterOpen}
            closePopup={closePopup}
            setSelectedEvent={setSelectedEvent}
          />
          {loader ? (
            <div className="flex justify-center items-center h-[80vh]">
              <div className="spinner"></div>
            </div>
          ) : (
            <div>
              {view === "Week" && (
                <CalendarWeekView
                  setTrialInfo={setTrialInfo}
                  currentDate={currentDate}
                  allEvents={allEvents}
                  selectedEvent={selectedEvent}
                  setSelectedEvent={setSelectedEvent}
                  closePopup={closePopup}
                  cancelMeeting={cancelMeeting}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  calOpen={calOpen}
                  setCalOpen={setCalOpen}
                  setMeetId={setMeetId}
                  handleCall={handleCall}
                  callCount={callCount}
                  fetchEvents={fetchEvents}
                  addToast={addToast}
                />
              )}
              {view === "Work Week" && (
                <WorkWeek
                  setTrialInfo={setTrialInfo}
                  currentDate={currentDate}
                  allEvents={allEvents}
                  selectedEvent={selectedEvent}
                  setSelectedEvent={setSelectedEvent}
                  closePopup={closePopup}
                  cancelMeeting={cancelMeeting}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  calOpen={calOpen}
                  setCalOpen={setCalOpen}
                  setMeetId={setMeetId}
                  handleCall={handleCall}
                  callCount={callCount}
                  fetchEvents={fetchEvents}
                  addToast={addToast}
                />
              )}
              {view === "Day" && (
                <DayView
                  setTrialInfo={setTrialInfo}
                  currentDate={currentDate}
                  allEvents={allEvents}
                  selectedEvent={selectedEvent}
                  setSelectedEvent={setSelectedEvent}
                  closePopup={closePopup}
                  cancelMeeting={cancelMeeting}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  calOpen={calOpen}
                  setCalOpen={setCalOpen}
                  setMeetId={setMeetId}
                  handleCall={handleCall}
                  callCount={callCount}
                  fetchEvents={fetchEvents}
                  addToast={addToast}
                />
              )}

              <div
                className={`fixed top-[70px] right-[-570px] h-full w-[570px] bg-white border-l border-[#C8D6E6] shadow-lg transition-transform duration-300 ease-in-out ${
                  isAgendaOpen || isRecruiterOpen
                    ? "translate-x-[-570px]"
                    : "translate-x-0"
                }`}
              >
                <div className="agendaCloseBtn">
                  <button
                    onClick={
                      isAgendaOpen
                        ? toggleAgenda
                        : isRecruiterOpen
                        ? toggleRecruiter
                        : ""
                    }
                    className="w-9 text-xl"
                  >
                    ✕
                  </button>
                </div>
                {isAgendaOpen ? (
                  <Agenda
                    setTrialInfo={setTrialInfo}
                    currentDate={currentDate}
                    allEvents={allEvents}
                    cancelMeeting={cancelMeeting}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    setMeetId={setMeetId}
                    handleCall={handleCall}
                  />
                ) : isRecruiterOpen ? (
                  <Recruiter
                    currentRecruiterId={currentRecruiter[0]?.recruiterID}
                    recID={recID}
                    recruiterData={recruiterDataHasCalendar}
                    fetchRecruiterPayload={fetchRecruiterPayload}
                    setfetchRecruiterPayload={setfetchRecruiterPayload}
                    fetchEvents={fetchEvents}
                    selectedValue={selectedValue}
                    isRecruiterOpen={isRecruiterOpen}
                    setIsRecruiterOpen={setIsRecruiterOpen}
                    selectedRecruiterId={selectedRecruiterId}
                    setSelectedRecruiterId={setSelectedRecruiterId}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    clearFilter={clearFilter}
                    setClearFilter={setClearFilter}
                    addToast={addToast}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Calendar;
